import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PageShell } from "@/components/layout/PageShell";
import { authApi } from "@/lib/adminApi";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    // Idempotent under StrictMode double-invocation.
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      toast.error("No session id in callback URL.");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const me = await authApi.exchangeSession(sessionId);
        await refresh();
        // Strip the fragment before navigating away.
        window.history.replaceState({}, "", window.location.pathname);
        if (me.role === "admin") {
          navigate("/admin/quotes", { replace: true });
        } else {
          toast.error("Signed in, but this account is not the authorised owner.");
          navigate("/", { replace: true });
        }
      } catch (err) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <PageShell>
      <section className="container py-14">
        <p className="eyebrow">Signing you in</p>
        <h1 className="mt-3 font-display text-3xl font-medium text-foreground">
          Completing sign-in&hellip;
        </h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground">
          Verifying your Google session with the NDIS 0138 Readiness backend. You will be
          redirected as soon as the server confirms authorisation.
        </p>
      </section>
    </PageShell>
  );
}
